import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    CardPedido,
    CardFaturamentoInexistente,
    Loading,
    CardErro,
    Header,
    Body,
    CardFaturamento,
    Titulo,
    InformativoFaturamento
} from '../../presentations';
import { SwiperCard } from '../../presentations/mobile';
import {
    PaginaEnum,
    StatusFaturamentoEnum
} from '../../enums';
import LogService from '../../services/LogService';
import { obterListagemFaturamento } from '../../redux/actions/FaturamentoAction';
import { obterListagemPedido } from '../../redux/actions/PedidoAction';
import { Grid, useMediaQuery } from '@material-ui/core';

function HomePage(
    {
        history,

        obterListagemFaturamento,
        obterListagemPedido,

        listagem_faturamento_loading,
        listagem_faturamento,
        listagem_faturamento_erro,

        listagem_pedido_loading,
        listagem_pedido,
        listagem_pedido_erro
    }
) {
    const mobile = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const ud = JSON.parse(localStorage.getItem('user_data'));

    useEffect(() => {
        if (ud.login) {
            LogService.registrarAcesso(PaginaEnum.HOME, PaginaEnum.properties[PaginaEnum.HOME].login);
            ud.login = false;
            localStorage.setItem('user_data', JSON.stringify(ud));
        }

        LogService.registrarAcesso(PaginaEnum.HOME, PaginaEnum.properties[PaginaEnum.HOME].acesso);
    }, [ud]);

    useEffect(() => {
        listagem_faturamento == null && obterListagemFaturamento();
    }, [listagem_faturamento, obterListagemFaturamento]);

    useEffect(() => {
        listagem_pedido == null && obterListagemPedido();
    }, [listagem_pedido, obterListagemPedido]);

    return (
        <>
            <Header titulo={`Olá, ${ud.primeiroNomeUsuario}!`} />
            <Body>
                {
                    (() => {
                        if (listagem_faturamento_loading === null ||
                            listagem_faturamento_loading === true ||
                            listagem_pedido_loading === null ||
                            listagem_pedido_loading === true)
                            return <Loading />

                        if (listagem_faturamento_erro !== null ||
                            listagem_pedido_erro !== null)
                            return <CardErro />

                        return (
                            <>
                                {
                                    (() => {
                                        if (listagem_faturamento.length === 0)
                                            return <>
                                                <Grid container>
                                                    <Grid item
                                                        sm={4}>
                                                        <CardFaturamentoInexistente />
                                                    </Grid>
                                                </Grid>
                                            </>

                                        let mostrarInformativo = listagem_faturamento.filter(x => x.codigoSituacao === StatusFaturamentoEnum.EM_ATRASO).length > 0;

                                        if (mobile) {
                                            let listagemFaturamento = listagem_faturamento.map((item, index) => (
                                                <div key={index}
                                                    style={{ paddingBottom: 25 }}>
                                                    <CardFaturamento faturamento={item} />
                                                </div>
                                            ))

                                            return <>
                                                {
                                                    mostrarInformativo && <InformativoFaturamento />
                                                }
                                                <SwiperCard lista={listagemFaturamento}
                                                    index={listagemFaturamento.length} />
                                            </>
                                        }

                                        return <>
                                            {
                                                mostrarInformativo && <InformativoFaturamento />
                                            }
                                            <Grid container
                                                spacing={2}>
                                                {
                                                    listagem_faturamento.map((item, index) => (
                                                        <Grid key={index}
                                                            item
                                                            sm={4}>
                                                            <CardFaturamento faturamento={item} />
                                                        </Grid>))
                                                }
                                            </Grid>
                                        </>
                                    })()
                                }
                                {
                                    (() => {
                                        if (listagem_pedido.length > 0) {
                                            let titulo = listagem_pedido.length === 1 ?
                                                <Titulo texto='Meu carro' /> :
                                                <Titulo texto='Meus carros' />

                                            if (mobile) {
                                                let listagemPedido = listagem_pedido.map((item, index) => (
                                                    <div key={index}
                                                        style={{ paddingBottom: 25 }}>
                                                        <CardPedido pedido={item} />
                                                    </div>
                                                ))

                                                return <>
                                                    {titulo}
                                                    <SwiperCard lista={listagemPedido} />
                                                </>
                                            }

                                            return <>
                                                {titulo}
                                                <Grid container
                                                    spacing={2}>
                                                    {
                                                        listagem_pedido.map((item, index) => (
                                                            <Grid key={index}
                                                                item
                                                                sm={4}>
                                                                <CardPedido pedido={item} />
                                                            </Grid>))
                                                    }
                                                </Grid>
                                            </>
                                        }
                                    })()
                                }
                            </>
                        );
                    })()
                }
            </Body>
        </>
    );
}

const mapStateToProps = (state) => ({
    listagem_faturamento_loading: state.faturamento.listagem_faturamento_loading,
    listagem_faturamento: state.faturamento.listagem_faturamento,
    listagem_faturamento_erro: state.faturamento.listagem_faturamento_erro,

    listagem_pedido_loading: state.pedido.listagem_pedido_loading,
    listagem_pedido: state.pedido.listagem_pedido,
    listagem_pedido_erro: state.pedido.listagem_pedido_erro
});

const mapDispatchToProps = {
    obterListagemFaturamento,
    obterListagemPedido
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);